import axios, { InternalAxiosRequestConfig } from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export const axiosFormDataInstance = axios.create({
  baseURL: API_BASE_URL,
});


// 👇 Shared auth interceptor
const authInterceptor = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  let token: string | null = localStorage.getItem("fhims_auth_token");

  if (!token) {
    const storedUser = localStorage.getItem("fhims_auth_user");
    if (storedUser) {
      const parsed: {
        token?: string;
        accessToken?: string;
        jwtToken?: string;
      } = JSON.parse(storedUser);

      token = parsed.token || parsed.accessToken || parsed.jwtToken || null;
    }
  }

  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }

  return config;
};

axiosInstance.interceptors.request.use(authInterceptor);
axiosFormDataInstance.interceptors.request.use(authInterceptor);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const responseInterceptor = (error: any) => {
  if (error.response?.status === 401) {
    localStorage.removeItem("fhims_auth_user");
    localStorage.removeItem("fhims_auth_token");
    localStorage.removeItem("fhims_menu");
    localStorage.removeItem("fhims_loginId");

    if (window.location.pathname !== "/") {
      window.location.href = "/";
    }
  }

  return Promise.reject(error);
};

axiosInstance.interceptors.response.use(
  (res) => res,
  responseInterceptor
);

axiosFormDataInstance.interceptors.response.use(
  (res) => res,
  responseInterceptor
);

export default axiosInstance;
